export class RegisterTariff {
    TariffTypeID = 1;
    CurrencyID?: number;
    Price?: number;
    Code?: string;
    Title?: string;
    Duration?: number;
    Discount = 0;
    PaymentMethodTypeID: number;
    StartWeekDay: string;
    EndWeekDay: string;
    StartHour = '00';
    EndHour = '24';

    // Web properties
    IsSaved = false;
    id = 0;
}
